import Link from 'next/link'
import { Icon } from '@scalis/components'

interface ListItemProps {
  icon: string
  text: string
  href: string
}

export const ListItem = ({ icon, text, href }: ListItemProps) => {
  return (
    <Link
      href={href}
      className='p-2 flex items-center gap-2 bg-neutral-00 hover:bg-neutral-10 rounded-lg'
    >
      <Icon className={icon} />
      <span className='body-small-basic'>{text}</span>
    </Link>
  )
}
